import { RouteRedirect } from '../../modules/routing-module';
import { FC } from 'react';

export const Accountant: FC = () => (
  <RouteRedirect routeKey="AccountantInvoices" />
);
